export default "__VITE_ASSET__VKi6sZoc__"